import { createContext, useContext } from 'react';

import type { IActions } from '../interface/IAction';
import type { IStates } from '../interface/IReducer';

export interface IRedux {
	states: IStates;
	actions: IActions;
}

/** @deprecated Use `useReduxActions()` for actions or `useSlice()` for state */
export const ReduxContext = createContext<IRedux | null>(null);

export const ActionsContext = createContext<IActions | null>(null);
export const StatesContext = createContext<IStates | null>(null);

/** @deprecated Use `useReduxActions()` for actions-only, or `useSlice('_user')` for scoped state */
export const useReduxContext = (): IRedux => {
	const states = useContext(StatesContext);
	const actions = useContext(ActionsContext);

	if (!states || !actions) {
		throw new Error('useReduxContext must be used within a ReduxProvider');
	}

	return { states, actions };
};
